import {
  Box,
  Flex,
  HStack,
  Link,
  Image,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Text,
  Button,
  Avatar,
  MenuDivider,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useNavigate, useLocation, Link as RouterLink } from "react-router-dom";
import logo from "../../assets/senca/logo.jpg";
import { FaBuilding } from "react-icons/fa";

import authService from "../../routes/authService";
import { useUser } from "../Navbar/UserContext";

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    currentUser,
    userCompanyInfo,
    userDescriptionInfo,
    userNameFromEmployees,
    hasFeature,
    isLoadingUser,
    refreshUserData,
  } = useUser();

  if (isLoadingUser) {
    return null;
  }

  const handleLogout = () => {
    authService.logout();
    refreshUserData();
    navigate("/login");
  };

  const displayName =
    userNameFromEmployees ||
    currentUser?.name ||
    currentUser?.login ||
    "Usuário";
  const avatarName =
    userNameFromEmployees || currentUser?.name || currentUser?.login || "U";

  const canHome = hasFeature("HOME_OS");
  const canCreateOs = hasFeature("CRIACAO_OS");
  const canOptions = hasFeature("CADASTRO_OPCOES");
  const canUsers = hasFeature("USUARIOS");
  const canCompanies = hasFeature("EMPRESAS");
  const canDenuncias = hasFeature("DENUNCIAS");
  const canPermissions = hasFeature("PERMISSOES");
  const showAtendimentos = canCreateOs || canOptions;
  const logoTarget = "/";

  const handleLogoClick = (event) => {
    if (location.pathname === logoTarget) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <Box
      bg="gray.50"
      px={6}
      py={3}
      boxShadow="sm"
      position="sticky"
      top="0"
      zIndex="1000"
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Box
          as={RouterLink}
          to={logoTarget}
          onClick={handleLogoClick}
          display="inline-block"
          lineHeight={0}
          _hover={{ opacity: 0.9 }}
          title="Ir para o site institucional"
        >
          <Image
            src={logo}
            alt="Logo Senca Serviços e Engenharia"
            height="45px"
            cursor="pointer"
            pointerEvents="none"
          />
        </Box>

        <HStack spacing={8}>
          {canHome && (
            <Link onClick={() => navigate("/home")} fontWeight="medium">
              Home
            </Link>
          )}

          {showAtendimentos && (
            <Menu>
              <MenuButton
                as={Button}
                variant="ghost"
                fontWeight="medium"
                rightIcon={<ChevronDownIcon />}
              >
                Atendimentos
              </MenuButton>
              <MenuList>
                {canCreateOs && (
                  <MenuItem onClick={() => navigate("/criacao-os")}>
                    Criação de OS
                  </MenuItem>
                )}
                {canOptions && (
                  <MenuItem onClick={() => navigate("/cadastroOpcoes")}>
                    Cadastro Opcoes
                  </MenuItem>
                )}
              </MenuList>
            </Menu>
          )}

          {canUsers && (
            <Menu>
              <MenuButton
                as={Button}
                variant="ghost"
                fontWeight="medium"
                rightIcon={<ChevronDownIcon />}
              >
                Usuários
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => navigate("/usuario")}>
                  Consulta de Usuários
                </MenuItem>
                <MenuItem onClick={() => navigate("/cadastro-usuario")}>
                  Cadastro de Usuário
                </MenuItem>
              </MenuList>
            </Menu>
          )}

          {canCompanies && (
            <Menu>
              <MenuButton
                as={Button}
                variant="ghost"
                fontWeight="medium"
                rightIcon={<ChevronDownIcon />}
              >
                Empresas
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => navigate("/ConsultaEmpresas")}>
                  Consulta de Empresas
                </MenuItem>
                <MenuItem onClick={() => navigate("/CadastrarEmpresa")}>
                  Cadastro de Empresas
                </MenuItem>
              </MenuList>
            </Menu>
          )}

          {canDenuncias && (
            <Link
              onClick={() => navigate("/consulta-denuncias")}
              fontWeight="medium"
            >
              Denúncias
            </Link>
          )}

          {canPermissions && (
            <Link onClick={() => navigate("/permissoes")} fontWeight="medium">
              Permissões
            </Link>
          )}
        </HStack>

        <HStack spacing={4}>
          {userCompanyInfo && (
            <Box
              px={3}
              py={1}
              bg="gray.100"
              borderRadius="md"
              border="1px"
              borderColor="gray.300"
              display="flex"
              alignItems="center"
              gap={2}
            >
              <FaBuilding size={16} color="#4A5568" />
              <Text fontSize="sm" color="gray.700" fontWeight="medium">
                {userCompanyInfo}
              </Text>
            </Box>
          )}

          {currentUser && (
            <Menu>
              <MenuButton
                as={Button}
                variant="ghost"
                rightIcon={<ChevronDownIcon />}
                pr={0}
              >
                <HStack>
                  <Avatar size="sm" name={avatarName} />
                  <Text fontWeight="bold">{displayName}</Text>
                </HStack>
              </MenuButton>
              <MenuList>
                <MenuItem
                  as={Box}
                  _hover={{ bg: "transparent", cursor: "default" }}
                  px={3}
                  py={2}
                >
                  <Flex direction="column">
                    <Text fontWeight="bold">{displayName}</Text>
                    <Text fontSize="sm" color="gray.500">
                      {currentUser.login}
                    </Text>
                    {userDescriptionInfo && (
                      <Text fontSize="xs" color="gray.600" mt={1}>
                        {userDescriptionInfo}
                      </Text>
                    )}
                  </Flex>
                </MenuItem>
                <MenuDivider />
                <MenuItem onClick={handleLogout}>Sair</MenuItem>
              </MenuList>
            </Menu>
          )}
        </HStack>
      </Flex>
    </Box>
  );
}

export default Navbar;
